import gql from 'graphql-tag';

const cardElementDetails = gql`
  fragment cardElementDetails on CardElement {
    id
    type
    frame {
      x
      y
      width
      height
      rotation
    }
    z_index
  }
`;

export default cardElementDetails;
